/* Intent events only. Successful cart/checkout events belong to Shopify customer events. */
(() => {
  if (window.vlogaraPdpIntentBound) return;
  const configNode = document.getElementById('vlogara-pdp-intent-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  window.vlogaraPdpIntentBound = true;
  configNode.dataset.bound = 'true';
  const qa = () => {
    try { return new URLSearchParams(location.search).get('vlogara_qa') === '1' || sessionStorage.getItem('vlogara_qa') === '1'; }
    catch { return false; }
  };
  const preview = () => Boolean(window.Shopify?.previewMode || (window.Shopify?.theme && window.Shopify.theme.role !== 'main'));
  function send(name, params = {}) {
    const payload = {...config, ...params};
    if (qa() || preview()) {
      window.vlogaraPdpIntentLog ||= [];
      window.vlogaraPdpIntentLog.push({name, params: payload, sent: false});
      configNode.dataset.qaEvents = JSON.stringify(window.vlogaraPdpIntentLog);
      return;
    }
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
  }
  document.addEventListener('click', event => {
    const gallery = event.target.closest('[data-gallery-image], [data-vlogara-full]');
    if (gallery) send('vlogara_gallery_select', {image_label: gallery.getAttribute('aria-label') || ''});
    const compare = event.target.closest('a[data-compare-product]');
    if (compare) send('vlogara_compare_click', {target_product: compare.dataset.compareProduct});
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.vlogara-pdp__form, .vlogara-vt101__form, .vlogara-mobile-sticky-atc__form')) return;
    send('vlogara_add_to_cart_intent', {placement: form.matches('.vlogara-mobile-sticky-atc__form') ? 'mobile_sticky' : 'pdp_primary'});
  }, true);
  const comparison = document.querySelector('.vlogara-setup-comparison');
  if (comparison && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { send('vlogara_compare_view'); observer.disconnect(); }
    }, {threshold: 0.25});
    observer.observe(comparison);
  }
})();
